import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insomina-terms-conditions',
  templateUrl: './insomina-terms-conditions.component.html',
  styleUrls: ['./insomina-terms-conditions.component.css']
})
export class InsominaTermsConditionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
